import { IconProps } from "../../../types/style";

const NegetiveMiniSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M21.5868 2.6665H10.4134C5.56008 2.6665 2.66675 5.55984 2.66675 10.4132V21.5732C2.66675 26.4398 5.56008 29.3332 10.4134 29.3332H21.5734C26.4268 29.3332 29.3201 26.4398 29.3201 21.5865V10.4132C29.3334 5.55984 26.4401 2.6665 21.5868 2.6665Z"
          fill={color}
        />
        <path
          d="M21.3334 17H10.6667C10.1201 17 9.66675 16.5467 9.66675 16C9.66675 15.4533 10.1201 15 10.6667 15H21.3334C21.8801 15 22.3334 15.4533 22.3334 16C22.3334 16.5467 21.8801 17 21.3334 17Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default NegetiveMiniSVG;
